import React, { FunctionComponent, ReactElement } from 'react';
import { Radio } from '@empiriecom/module-components/FormControls';
import styled from 'styled-components';
import { Dimension } from '@/interfaces';
import { SetProduct } from '../types';
import { Header } from '../Header';

interface RadioProps {
  dimension: Dimension;
  setProduct: SetProduct;
}

const RadioContainer = styled.div`
  margin-bottom: 0.75rem;
`;

export const RadioWrapper: FunctionComponent<RadioProps> = ({
  dimension: { displayName, values },
  setProduct,
}): ReactElement => {
  const element = (
    <RadioContainer>
      <Header
        dimensionName={displayName}
        selectedValue={
          values.filter(({ isSelected }) => isSelected).map(({ displayText }) => displayText)[0]
        }
      />
      <div data-testid="product-selection-radio">
        {values.map(({ displayText, sku, isSelected }) => (
          <div key={displayText}>
            <Radio
              checked={isSelected}
              data-testid="product-selection-radio-element"
              label={displayText}
              name={displayName}
              onClick={() => !isSelected && setProduct(sku)}
              readOnly
            />
          </div>
        ))}
      </div>
    </RadioContainer>
  );
  return element;
};

export default RadioWrapper;
